export interface StorageSummary {
  usage: number;
  quota: number;
  persisted: boolean;
}

export async function getStorageSummary(): Promise<StorageSummary> {
  const estimate = await navigator.storage?.estimate();
  const persisted = (await navigator.storage?.persisted?.()) ?? false;
  return {
    usage: estimate?.usage ?? 0,
    quota: estimate?.quota ?? 0,
    persisted,
  };
}

export async function requestPersistentStorage(): Promise<boolean> {
  return (await navigator.storage?.persist?.()) ?? false;
}

export async function clearApplicationDatabases(): Promise<void> {
  if (!("databases" in indexedDB)) {
    throw new Error(
      "This browser cannot enumerate local databases. Use browser site-data settings.",
    );
  }

  await closeQuotationDraftDatabase();
  const databases = await indexedDB.databases();
  const names = databases
    .map((database) => database.name)
    .filter(
      (name): name is string =>
        typeof name === "string" &&
        (name.startsWith("quotation-") ||
          name.startsWith("qr-transfer-") ||
          name.startsWith("link-share-")),
    );

  for (const name of names) {
    await new Promise<void>((resolve, reject) => {
      const request = indexedDB.deleteDatabase(name);
      request.onsuccess = () => resolve();
      request.onerror = () =>
        reject(request.error ?? new Error(`Could not delete ${name}.`));
      request.onblocked = () =>
        reject(new Error(`Close other app tabs before deleting ${name}.`));
    });
  }
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) {
    return `${bytes} B`;
  }

  const units = ["KB", "MB", "GB", "TB"];
  let value = bytes / 1024;
  let unit = units[0] ?? "KB";

  for (const candidate of units) {
    unit = candidate;
    if (value < 1024 || candidate === units.at(-1)) {
      break;
    }
    value /= 1024;
  }

  return `${value.toFixed(value >= 10 ? 1 : 2)} ${unit}`;
}
import { closeQuotationDraftDatabase } from "../features/quotation/repository";
